(function(){
  var CFG = window.KAI_CONFIG || {};
  var THRESH = CFG.freeShipThreshold || 70;
  var CART = null;
  var CUR = 'EUR';
  var UPSELLS = [
    {name:'Raspberry', img:'https://cdn.shopify.com/s/files/1/1070/5023/8290/files/3_f621bf13-7d5b-4e02-8eea-8c94a6a92aa7.png?v=1781438696'},
    {name:'Tropical Mango', img:'https://cdn.shopify.com/s/files/1/1070/5023/8290/files/6_8c90d60d-4d14-496c-ad5b-d0486fed98d0.png?v=1781438696'},
    {name:'Blueberry Vanilla', img:'https://cdn.shopify.com/s/files/1/1070/5023/8290/files/3_28cedf52-0c75-48af-aee6-4cd58f22a820.png?v=1781438696'}
  ];

  // Gift names/values MUST match kai-body-2.liquid (value stack) and the buy box settings.
  // Tiers MUST match kai-flavmap.js wanted(): 2+ units = recipe/tote, 3+ units = + gift jar (Strawberry).
  var GIFTS = {
    recipe:{name:'Fan Favorite Sea Moss Recipes', value:490, icon:'\u{1F4D6}'},
    tote:{name:'KAI Coton Bag', value:1000, icon:'\u{1F6CD}\u{FE0F}'},
    shipping:{name:'Free Shipping', value:0, icon:'\u{1F69A}'},
    mango:{name:'Strawberry Sea Moss Gel', value:2690, img:'https://cdn.shopify.com/s/files/1/0846/9508/9495/files/PP_Strawberry-Photoroom.png?v=1788193584&width=400'}
  };
  // Count PAID units, not the Pack label. Every jar is its own line, so removing a line must
  // lower the tier - reading maxJars off the Pack property would keep saying "3 Jars" forever.
  function giftsForCart(){
    var units=0;
    ((CART&&CART.items)||[]).forEach(function(it){
      var p=it.properties||{};
      if(p['_gift']) return;
      units+=it.quantity;
    });
    if(units>=3) return ['recipe','tote','mango','shipping']; // 3. darilo = jagodni gel, 4. = free shipping (okus zamenjan 31. 8. 2026)
    if(units>=2) return ['recipe','tote'];
    return [];
  }
  var KAI_TIMER_MS=20*60*1000, _kti=null;
  function timerEnd(){
    try{ var k='kaiCartTimerEnd', now=Date.now(), v=localStorage.getItem(k);
      if(!v||parseInt(v,10)<=now){ v=String(now+KAI_TIMER_MS); localStorage.setItem(k,v); }
      return parseInt(v,10);
    }catch(e){ return Date.now()+KAI_TIMER_MS; }
  }
  function startTimer(){
    var box=document.getElementById('kai-cart-timer'), clock=document.getElementById('kai-timer-clock');
    if(!box||!clock) return;
    if(!CART||!CART.items.length){ box.style.display='none'; if(_kti){clearInterval(_kti);_kti=null;} return; }
    box.style.display='block';
    function upd(){ var rem=timerEnd()-Date.now(); if(rem<0)rem=0; var m=Math.floor(rem/60000), sec=Math.floor((rem%60000)/1000); clock.textContent=(m<10?'0':'')+m+':'+(sec<10?'0':'')+sec; }
    upd(); if(_kti) clearInterval(_kti); _kti=setInterval(upd,1000);
  }

  var root = document.createElement('div');
  root.id = 'kai-cart-root';
  root.innerHTML =
    '<div id="kai-cart-overlay"></div>' +
    '<aside id="kai-cart-drawer" aria-label="Cart">' +
      '<div class="kai-cart-head">' +
        '<span class="kai-cart-title">YOUR CART <span id="kai-cart-badge">0</span></span>' +
        '<button type="button" id="kai-cart-close" aria-label="Close">&times;</button>' +
      '</div>' +
      '<div id="kai-cart-timer" style="display:none;background:#E3E9EE;padding:9px 22px;font-size:12.5px;text-align:center;border-bottom:1px solid #E8E2DC;color:#080912"><span style="margin-right:5px">&#9202;</span>Your cart &amp; free gifts are held for <strong id="kai-timer-clock" style="color:#B4532E;font-variant-numeric:tabular-nums">20:00</strong></div>' +
      '<div class="kai-cart-ship"><p id="kai-ship-msg"></p><div class="kai-ship-track"><div id="kai-ship-bar"></div></div></div>' +
      '<div id="kai-cart-body"></div>' +
      '<div id="kai-cart-upsell"></div>' +
      '<div class="kai-cart-foot">' +
        '<div class="kai-cart-subrow"><span>Subtotal</span><span id="kai-cart-sub"></span></div>' +
        '<a href="/checkout" id="kai-cart-checkout" class="kai-cart-checkout">Checkout</a>' +
        '<a href="/cart" class="kai-cart-viewcart">View cart</a>' +
      '</div>' +
    '</aside>';
  document.body.appendChild(root);

  function money(cents){
    try { return (cents/100).toLocaleString(undefined,{style:'currency',currency:CUR}); }
    catch(e){ return '€'+(cents/100).toFixed(2); }
  }
  function open(){ root.classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function close(){ root.classList.remove('open'); document.documentElement.style.overflow=''; }
  window.kaiOpenCart = function(){ fetchCart(open); };
  window.kaiCloseCart = close;
  // kai-flavmap.js calls this after it sweeps orphaned gifts, so the drawer repaints.
  window.kaiRefreshCart = function(){ fetchCart(); };

  document.getElementById('kai-cart-close').onclick = close;
  document.getElementById('kai-cart-overlay').onclick = close;
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });

  function fetchCart(cb){
    fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}})
      .then(function(r){return r.json();})
      .then(function(c){ CART=c; if(c.currency) CUR=c.currency; render(); updateBadges(); if(cb) cb(); })
      .catch(function(){ if(cb) cb(); });
  }
  function updateBadges(){
    var n = CART ? CART.item_count : 0;
    var b=document.getElementById('kai-cart-badge'); if(b) b.textContent=n;
    var hb=document.getElementById('kai-cart-count'); if(hb) hb.textContent=n;
  }
  function render(){
    if(!CART) return;
    var body=document.getElementById('kai-cart-body');
    var sub = CART.items_subtotal_price;
    var threshCents = THRESH*100;
    var remain = threshCents - sub;
    var msg=document.getElementById('kai-ship-msg');
    var bar=document.getElementById('kai-ship-bar');
    if(remain>0){ msg.innerHTML='You\'re '+money(remain)+' away from <strong>FREE shipping</strong>'; }
    else { msg.innerHTML='🎉 You\'ve unlocked <strong>FREE shipping!</strong>'; }
    bar.style.width=Math.min(100, Math.round((sub/threshCents)*100))+'%';
    if(!CART.items.length){
      body.innerHTML='<div class="kai-cart-empty"><p>Your cart is empty.</p></div>';
      document.getElementById('kai-cart-upsell').innerHTML='';
      document.getElementById('kai-cart-sub').textContent=money(0);
      startTimer();
      return;
    }
    var h='';
    CART.items.forEach(function(it,idx){
      var p = it.properties || {};
      // Gift lines are rendered in the gifts block below, never as a removable paid line.
      if(p['_gift']) return;
      var isPack = !!p['Pack'];
      var name = p['Flavour'] || it.product_title;
      var img = p['_img'] || it.image || '';
      var bits = [];
      if(it.variant_title) bits.push(it.variant_title);
      if(p['Pack']) bits.push(p['Pack']);
      if(p['Purchase type']) bits.push('Subscription');
      var props = bits.length ? '<span>'+bits.join('</span><span>')+'</span>' : '';
      var qtyCtrl = isPack
        ? '<div class="kai-ci-qty kai-ci-qty-lock"><span>Qty '+it.quantity+'</span></div>'
        : '<div class="kai-ci-qty">'+
            '<button type="button" class="kai-qd" data-line="'+(idx+1)+'" data-q="'+(it.quantity-1)+'">&minus;</button>'+
            '<span>'+it.quantity+'</span>'+
            '<button type="button" class="kai-qd" data-line="'+(idx+1)+'" data-q="'+(it.quantity+1)+'">+</button>'+
          '</div>';
      h+='<div class="kai-ci" data-line="'+(idx+1)+'">'+
           '<img src="'+img+'" alt="">'+
           '<div class="kai-ci-mid">'+
             '<p class="kai-ci-title">'+name+'</p>'+
             '<div class="kai-ci-props">'+props+'</div>'+
             qtyCtrl+
           '</div>'+
           '<div class="kai-ci-right">'+
             '<p class="kai-ci-price">'+money(it.final_line_price)+'</p>'+
             '<button type="button" class="kai-ci-rm" data-line="'+(idx+1)+'">Remove</button>'+
           '</div>'+
         '</div>';
    });
    var _g=giftsForCart();
    if(_g.length){
      h+='<div style="margin-top:6px;padding-top:10px;border-top:1px dashed #DDD5CC">'+
         '<p style="font-size:11px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;color:#080912;margin:0 0 4px">&#127873; '+_g.length+' free gifts included</p>';
      _g.forEach(function(gid){ var g=GIFTS[gid];
        var struck = g.value ? '<span style="color:#46505A;font-weight:500;text-decoration:line-through">'+money(g.value)+'</span> ' : '';
        h+='<div class="kai-ci" style="border-bottom:none;padding:8px 0">'+
             '<div style="width:62px;height:62px;border-radius:10px;background:#E3E9EE;display:flex;align-items:center;justify-content:center;font-size:26px;flex-shrink:0;overflow:hidden">'+(g.img?'<img src="'+g.img+'" alt="" style="height:42px;width:auto;object-fit:contain">':g.icon)+'</div>'+
             '<div class="kai-ci-mid"><p class="kai-ci-title">'+g.name+'</p><div class="kai-ci-props"><span>Free bonus with your pack</span></div></div>'+
             '<div class="kai-ci-right" style="justify-content:center"><p class="kai-ci-price">'+struck+'<span style="color:#080912;font-weight:800">FREE</span></p></div>'+
           '</div>';
      });
      h+='</div>';
    }
    body.innerHTML=h;
    document.getElementById('kai-cart-sub').textContent=money(sub);
    body.querySelectorAll('.kai-qd').forEach(function(b){ b.onclick=function(){ changeLine(this.getAttribute('data-line'), parseInt(this.getAttribute('data-q'),10)); }; });
    body.querySelectorAll('.kai-ci-rm').forEach(function(b){ b.onclick=function(){ changeLine(this.getAttribute('data-line'), 0); }; });
    renderUpsell();
    startTimer();
  }
  function changeLine(line, qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({line:parseInt(line,10),quantity:qty})})
      .then(function(r){return r.json();})
      .then(function(c){ CART=c; render(); updateBadges(); });
  }
  function renderUpsell(){
    var wrap=document.getElementById('kai-cart-upsell');
    var PM=window.KAI_PRICEMAP||{};
    var vid=PM['Standard~1-Jar Pack'];
    if(!vid){ wrap.innerHTML=''; return; }
    var cards='';
    UPSELLS.forEach(function(u){
      cards+='<div class="kai-up-card">'+
        '<img src="'+u.img+'" alt="">'+
        '<div class="kai-up-mid"><p class="kai-up-name">'+u.name+'</p><p class="kai-up-sub">1 jar · add-on</p></div>'+
        '<button type="button" class="kai-up-add" data-name="'+u.name+'" data-img="'+u.img+'">+ Add</button>'+
        '</div>';
    });
    wrap.innerHTML='<p class="kai-up-head">Add &amp; save - popular flavours</p>'+cards;
    wrap.querySelectorAll('.kai-up-add').forEach(function(b){ b.onclick=function(){ var nm=this.getAttribute('data-name'); var im=this.getAttribute('data-img'); this.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:[{id:parseInt(vid,10),quantity:1,properties:{'Flavour':nm,'_img':im}}]})})
        .then(function(r){return r.json();}).then(function(){ fetchCart(); }); }; });
  }
  // intercept the buy-box Add-to-Cart (capture phase, before the native submit)
  function hookForm(){
    var f=document.getElementById('kai-form');
    if(!f) return;
    f.addEventListener('submit', function(e){
      e.preventDefault(); e.stopImmediatePropagation();
      // Block until every jar in the pack has a flavour chosen.
      if(window.kaiValidate && !window.kaiValidate()){ return; }
      var items=window.KAI_ADD_ITEMS;
      if(!items || !items.length){ var fp=document.getElementById('kai-flavours'); if(fp) fp.scrollIntoView({behavior:'smooth',block:'center'}); return; }
      var btn=document.getElementById('kai-atc'); var orig=btn?btn.textContent:'';
      if(btn) btn.textContent='Adding…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify({items:items})})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          if(!res.ok){ // e.g. helper product not yet active/published → Shopify 422
            if(btn) btn.textContent = (res.d && res.d.description) ? 'Unavailable - try again' : orig;
            setTimeout(function(){ if(btn) btn.textContent=orig; }, 2200);
            return;
          }
          window.kaiOpenCart(); if(btn) btn.textContent=orig;
        })
        .catch(function(){ if(btn) btn.textContent=orig; });
    }, true);
  }
  function hookHeader(){
    var link=document.getElementById('kai-cart-link');
    if(link){ link.addEventListener('click',function(e){ e.preventDefault(); window.kaiOpenCart(); }); }
  }
  function brandFixups(){
    // footer wordmark -> serif KAI (match header logo)
    var spans=document.querySelectorAll('footer span');
    for(var i=0;i<spans.length;i++){
      if(spans[i].textContent==='HEALTH'){
        spans[i].style.display='none';
        var prev=spans[i].previousElementSibling;
        if(prev){ prev.style.fontFamily="'Times New Roman',Georgia,serif"; prev.style.fontWeight='600'; prev.style.letterSpacing='0.18em'; }
      }
    }
  }
  function init(){ hookHeader(); hookForm(); brandFixups(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
  fetchCart();
})();